import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const NotificationContext = createContext(null);

// Глобальный объект для доступа к функции показа нотификаций из axios interceptor
let globalShowNotification = null;

export const setGlobalShowNotification = (fn) => {
    globalShowNotification = fn;
};

export const showGlobalNotification = (message, severity = 'error') => {
    if (globalShowNotification) {
        globalShowNotification(message, severity);
    }
};

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    const showNotification = useCallback((message, severity = 'error') => {
        const id = Date.now() + Math.random();
        const notification = {
            id,
            message,
            severity // 'error', 'warning', 'info', 'success'
        };
        
        setNotifications(prev => [...prev, notification]);
        
        // Автоматически удаляем через 6 секунд
        setTimeout(() => {
            setNotifications(prev => prev.filter(n => n.id !== id));
        }, 6000);
        
        return id;
    }, []);

    const hideNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    const clearAll = useCallback(() => {
        setNotifications([]);
    }, []);

    // Регистрируем функцию показа нотификаций в глобальном объекте
    useEffect(() => {
        setGlobalShowNotification(showNotification);
        return () => {
            setGlobalShowNotification(null);
        };
    }, [showNotification]);

    return (
        <NotificationContext.Provider value={{ 
            showNotification, 
            hideNotification, 
            clearAll,
            notifications 
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within NotificationProvider');
    }
    return context;
};

